<template>
  <div>
    <div class="indexBox waitingSeason" style="margin-top: 80px;">
      <div class="container">
        <img src="@/assets/img/fanzone/md_point_2025.jpg" alt="md_point_info"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PointHistory',
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>
</style>
